import { makeStyles } from '@rbx/ui';
import styles from '@modules/ui/shared/utils/styles';

const useConfirmDialogStyles = makeStyles()(() => ({
  wordWrap: styles.wordBreakWrap,
}));

export default useConfirmDialogStyles;
